import { render, staticRenderFns } from "./BundleSummary.vue?vue&type=template&id=b901ab24&scoped=true&"
import script from "./BundleSummary.vue?vue&type=script&lang=js&"
export * from "./BundleSummary.vue?vue&type=script&lang=js&"
import style0 from "./BundleSummary.vue?vue&type=style&index=0&id=b901ab24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b901ab24",
  null
  
)

export default component.exports